import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Page } from "src/app/util/page";
import { Rma } from "./rma";
import { RmaSearchResult } from "./rma-search-result";
import { SearchRequest } from "./search-request";

@Injectable()
export class RmaService {
  constructor(private httpClient: HttpClient) { }

  public addReferenceToRma(isbn: string, rma: number): Observable<Rma> {
    return this.httpClient.put<Rma>("/api/inventory/rma/" + rma + "/" + isbn, {});
  }

  public cancel(rma: number): Observable<void> {
    return this.httpClient.post<void>("/api/inventory/rma/" + rma + "?cancel", {});
  }

  public confirm(rma: number): Observable<void> {
    return this.httpClient.post<void>("/api/inventory/rma/" + rma + "?confirm", {});
  }

  public findByNumber(number: number) {
    return this.httpClient.get<Rma>("/api/inventory/rma/" + number);
  }

  public newRmaBySupplier(supplier: string): Observable<Rma> {
    return this.httpClient.post<Rma>("/api/inventory/rma?supplier=" + supplier, {});
  }

  public removeDetail(rma: number, isbn: string): Observable<void> {
    return this.httpClient.delete<void>("/api/inventory/rma/" + rma + "/" + isbn);
  }

  public updateQuantity(quantity: number, isbn: string, rma: number): Observable<void> {
    return this.httpClient.put<void>("/api/inventory/rma/" + rma + "/" + isbn + "?quantity=" + quantity, {});
  }

  public search(searchRequest: SearchRequest, page: number, size: number): Observable<Page<RmaSearchResult>> {
    return this.httpClient.post<Page<RmaSearchResult>>("/api/inventory/rma?search&page=" + page + "&size=" + size + "&sort=creationTimestamp,DESC", searchRequest);
  }
}